export default __webpack_public_path__ + "static/erc2x-fb5573b1085a7807048c879157740411.png";